import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/fonts.css';
import './styles/tokens.css';
import './styles/global.css';
import './styles/components.css';
import './styles/markdown.css';

import { App } from './shell/app.tsx';
import { applyUiScale } from './lib/display.ts';
import { applyAppearance } from './lib/themes.ts';
import { applyTypography } from './lib/typography.ts';
import { createLiveStore } from './live/store.ts';
import { startClientTiming } from './lib/client-timing.ts';

// Before first paint, so the login screen is already at the operator's scale.
applyUiScale();
applyAppearance();
applyTypography();
startClientTiming();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

// One store for the process lifetime. StrictMode double-invokes effects in development, so
// the store owns its own guard against a duplicate EventSource rather than relying on being
// mounted exactly once.
const store = createLiveStore();

createRoot(root).render(
  <StrictMode>
    <App store={store} />
  </StrictMode>,
);
